/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { EShapeFill } from "./shape/e-shape-fill";

export interface DDiagramLayerBackground extends EShapeFill {}
